import { format } from 'date-fns';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
dayjs.extend(timezone);

export const getProperDate = (sourceDate: string) => {
  const tzOffset = new Date().getTimezoneOffset();

  const dt = dayjs(sourceDate).utcOffset(tzOffset, true).subtract(3, 'h');

  return dt.format('DD/MM/YYYY HH:mm');
};

export const getProperDateTransactions = (sourceDate: string) => {
  const tzOffset = new Date().getTimezoneOffset();

  const dt = dayjs(sourceDate).utcOffset(tzOffset, true).add(3, 'h');

  return dt.format('DD/MM/YYYY HH:mm');
};

export const getDateFormatted = (sourceDate: string) => {
  const dt = new Date(sourceDate);

  return format(new Date(dt.getFullYear(), dt.getUTCMonth(), dt.getUTCDate()), 'dd/MM/yyyy');
};

export const getDateFormattedTwo = (sourceDate: string) => {
  const dt = new Date(sourceDate);

  return format(new Date(dt.getFullYear(), dt.getUTCMonth(), dt.getUTCDate()), 'yyyy-MM-dd');
};
export const getFormatedDateWithHours = (sourceDate?: string | number) => {
  const dt = dayjs(sourceDate);

  return dt.format('DD/MM/YYYY HH:mm').concat('hs');
};

export const sortDateDesc = (a?: string, b?: string) => {
  return dayjs(a).isBefore(dayjs(b)) ? 1 : 0;
};
